export default "__VITE_ASSET__79a0e41c__"